// removed by extract-text-webpack-plugin
module.exports = {"Modal":"bigModal__Modal__26u1s","Close":"bigModal__Close__3bKIz","Description":"bigModal__Description__otXDg","Message":"bigModal__Message__25Tcs","Error":"bigModal__Error__2H8JH","Row":"bigModal__Row__3WbXG","Or":"bigModal__Or__2Hs1F"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Modal/bigModal.css
// module id = 907
// module chunks = 2